import { FaAddressBook, FaPhone, FaEnvelope, FaInstagram, FaPrint } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Config from '../Header/Config';
export default function Invoice() {
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [grandTotal, setGrandTotal] = useState('');
  const [discount, setDiscount] = useState('');
  const [subTotal, setSubTotal] = useState('');
  const [invoice, setInvoice] = useState('');
  const [tableData, setTableData] = useState('');
  const [BuyBackData, setBuyBackData] = useState([]);

  const [BuyBackModel, setBuyBackModel] = useState('');
  const [loading, setLoading] = useState(true);
  //................................{ set data in invoice }...............................
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invoice_Number = searchParams.get('invoice_no');
  const invoice_brand = searchParams.get('invoice_no');

  const navigate = useNavigate();
  const apiUrl = Config.apiUrl;

  //......................{ fetch brand details }.......................

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_SalesInvoice/${invoice_Number}`);
        const result = await response.json();

        // New API response format: { sales_details, sales_items, brand_details }
        if (result.status === 'success') {
          const salesDetails = result.sales_details || {};
          const salesItems = result.sales_items || [];
          const brandDetails = result.brand_details || [];

          // Set customer and invoice details from sales_details
          setName(salesDetails.customer_name || '');
          setDate(salesDetails.date || '');
          setMobileNumber(salesDetails.mobile_no || '');
          setGrandTotal(salesDetails.grand_total || '0');
          setSubTotal(salesDetails.sub_total || '0');
          setInvoice(salesDetails.invoice_no || '');

          // Set sales items (regular items)
          setTableData(salesItems);

          // Calculate discount as sum of all item discounts from sales_items
          const totalDiscount = salesItems.reduce((sum, item) => {
            const itemDiscount = parseFloat(item.discount?.toString().replace(/[,\s]/g, '') || '0') || 0;
            return sum + itemDiscount;
          }, 0);
          setDiscount(totalDiscount.toString());

          // Set buyback items (brand_details)
          setBuyBackData(brandDetails);

          console.log('Sales Items:', salesItems);
          console.log('Buyback Items:', brandDetails);

          setLoading(false);
        } else {
          console.error('API returned error:', result.message);
          setLoading(false);
        }

      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    if (invoice_Number) {
      fetchData();
    }
  }, [invoice_Number, apiUrl]);

  const handleBack = () => {
    navigate(-1);
  };

  const [showDiv, setShowDiv] = useState(true);

  const handlePrint = () => {
    setShowDiv(false);
    setTimeout(() => {
      window.print();
      setShowDiv(true);
    }, 0);
  };

  const handleWhatsAppShare = () => {
    // Check if mobile number exists
    if (!mobileNumber || mobileNumber.toString().trim() === '') {
      alert('Mobile number is not available. Please check the bill details.');
      return;
    }

    // Format phone number (remove all non-numeric characters)
    let phoneNumber = mobileNumber.toString().replace(/[^0-9]/g, '');
    
    console.log('Original mobileNumber:', mobileNumber);
    console.log('Cleaned phoneNumber:', phoneNumber);
    
    // Remove leading 0 if present
    if (phoneNumber.startsWith('0')) {
      phoneNumber = phoneNumber.substring(1);
    }
    
    // If number starts with 91 and has 12 digits, keep it
    // If number has 10 digits, add 91 prefix
    if (phoneNumber.length === 10) {
      phoneNumber = '91' + phoneNumber;
    } else if (phoneNumber.startsWith('91') && phoneNumber.length === 12) {
      // Already has country code, keep as is
    } else if (phoneNumber.length < 10) {
      alert(`Invalid mobile number format: ${mobileNumber}. Please check the bill details.`);
      return;
    }
    
    console.log('Final formatted phoneNumber for WhatsApp:', phoneNumber);

    // Create standard formatted message with important details
    let message = `*Mobile City Gadhinglaj*\n\n`;
    message += `Hello ${name},\n\n`;
    message += `Thank you for your purchase!\n\n`;
    message += `*Invoice Details:*\n`;
    message += `Invoice No: ${invoice_Number}\n`;
    message += `Date: ${date}\n\n`;
    
    // Add product details
    message += `*Products Purchased:*\n`;
    if (Array.isArray(tableData) && tableData.length > 0) {
      tableData.forEach((row, index) => {
        message += `${index + 1}. ${row.model_name}\n *IMEI:* ${row.imei}\n`;
      });
    }

    // Add buyback items if any
    if (Array.isArray(BuyBackData) && BuyBackData.length > 0) {
      BuyBackData.forEach((row, index) => {
        const itemNumber = (Array.isArray(tableData) ? tableData.length : 0) + index + 1;
        message += `${itemNumber}. ${row.model_name} (Buyback)\n`;
      });
    }
    
    message += `\n*Total Amount: ₹${grandTotal}/-*\n\n`;
    message += `We appreciate your business! 🙏\n\n`;
    message += `For any queries, contact us:\n`;
    message += ` Mobile No:+91 9006500607\n`;
    message += ` Address: Doctor colony Near tejam hospital Gahdhinglaj dist-kolhapur Pin- 416 502\n\n`;
    message += ` Please share your Review on Google: https://tinyurl.com/yd8u7dth\n`;
    message += ` Instagram Link: https://www.instagram.com/invites/contact/?igsh=159hmn4msi1xq&utm_content=nn8mlcf\n`;
    message += ` Whatsapp Group Link: https://chat.whatsapp.com/KmcdVDNqFac6izlmAqPLoR`;

    // Encode message for URL - encodeURIComponent properly encodes UTF-8 emojis for WhatsApp
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    const handleBeforePrint = () => {
      setShowDiv(false);
    };

    const handleAfterPrint = () => {
      setShowDiv(true);
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);



  return (


    <>

      <section style={{ backgroundColor: "white" }}>
        <div style={{ margin: 'auto', padding: '30px 24%', position: 'relative' }} className="no-print">

          {showDiv && (
            <>
              <div style={{ margin: "auto", padding: "0px 0px", position: "relative", maxWidth: "210mm" }}>
                <div style={{ float: "left" }}>
                  <button className='btn btn-outline-primary' onClick={handleBack}>Back</button>
                </div>
                <div style={{ float: "right", display: "flex", gap: "10px" }}>
                  <button className='btn btn-outline-success' onClick={handleWhatsAppShare} style={{ backgroundColor: "#25D366", color: "white", borderColor: "#25D366" }}>
                    <FaWhatsapp style={{ marginRight: "5px" }} /> WhatsApp Share
                  </button>
                  <button className='btn btn-outline-danger' onClick={handlePrint}><FaPrint className="icon_color" /></button>
                </div>
              </div>
            </>
          )}
        </div>



        <div className="invoice-box">
          <div className="invoice-header">
            <div className="flex">
              <table style={{ border: "1px solid #dddddd" }}>
                <tbody >
                  <tr>

                    <p className="arihant" style={{ margin: "5px 0 0 0" }}>
                      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ width: "70%" }}>
                          <img style={{ paddingTop: "0px" }} src="assets/img/a4.jpg" width="150" height="90" />

                        </div>

                      </div>
                    </p>
                    <td style={{ width: "40%" }}>
                      <p style={{ lineHeight: "1.3", fontSize: "12px", margin: "2px 0" }}>
                        <p style={{ margin: "2px 0", fontSize: "12px" }}><strong>GST No: 27DEJPG8013K1ZB</strong></p>
                        <p style={{ margin: "2px 0", fontSize: "12px" }}><FaAddressBook /> Baburao</p>
                        <p style={{ margin: "2px 0", fontSize: "12px" }}><FaPhone /> +91 9006500607</p>
                        <p style={{ margin: "2px 0", fontSize: "12px" }}><FaInstagram /> @Mobilecitygadhinglaj</p>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}>
              <tbody>
                <tr>
                  <td style={{ padding: "5px", textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", flexWrap: "wrap", gap: "5px" }}>
                      <img src="https://www.pngkey.com/png/detail/107-1074224_free-apple-logo-png-transparent-background-essential-iphone.png" style={{ width: "80px", height: "20px", objectFit: "contain" }} alt="iPhone" />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/a/a4/OnePlus_logo.png" style={{ width: "80px", height: "20px", objectFit: "contain" }} alt="OnePlus" />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/6/61/Samsung_old_logo_before_year_2015.svg" alt="Samsung" style={{ width: "80px", height: "18px", objectFit: "contain" }} />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/e/e5/Vivo_mobile_logo.png" alt="Vivo" style={{ width: "60px", height: "18px", objectFit: "contain" }} />
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQhZy3P7TFqM1fUohEYPLfbN1N3_oIUzfUqaZhVq8&s" alt="Xiaomi" style={{ width: "20px", height: "20px", objectFit: "contain" }} />
                      <img src="https://upload.wikimedia.org/wikipedia/commons/a/a2/OPPO_LOGO_2019.png" alt="Oppo" style={{ width: "70px", height: "25px", objectFit: "contain" }} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ backgroundColor: "#531aff", color: "white", padding: "5px", textAlign: "center" }}>
                    <b style={{ fontSize: "11px" }}>BRANCH 1- Doctors Colony, Near Tejam Hospital, Gadhinglaj. Dist- Kolhapur Pin- 416 502</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ height: "2px", padding: 0 }}></td>
              </tr>
              <tr>
                  <td style={{ backgroundColor: "#531aff", color: "white", padding: "5px", textAlign: "center" }}>
                    <b style={{ fontSize: "11px" }}>BRANCH 2- Shop No 04, Opp Bus Stand Link Road, Sankeshwar, Dist- Belagavi Pin-591313</b>
                </td>
              </tr>
              </tbody>
            </table>

            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", marginBottom: "8px" }}>
              <tbody>
                <tr>
                  <td style={{ width: "50%", padding: "6px 8px", verticalAlign: "top" }}>
                    <p style={{ margin: "2px 0", fontSize: "11px" }}><b>Name:</b> {name}</p>
                    <p style={{ margin: "2px 0", fontSize: "11px" }}><b>Mobile No:</b> {mobileNumber}</p>
                  </td>
                  <td style={{ width: "50%", padding: "6px 8px", verticalAlign: "top", textAlign: "right" }}>
                    <p style={{ margin: "2px 0", fontSize: "11px" }}><b>Date:</b> {date}</p>
                    <p style={{ margin: "2px 0", fontSize: "11px" }}><b>Invoice No:</b> {invoice_Number}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ position: "relative" }}>
            <img 
              src="assets/img/Buy and Exchane Logo.png" 
              alt="Buy and Exchange Logo" 
              style={{ 
                position: "absolute", 
                top: "100%", 
                left: "50%", 
                transform: "translate(-50%, -50%)", 
                width: "300px", 
                height: "auto", 
                opacity: 0.12, 
                zIndex: 0, 
                pointerEvents: "none"
              }} 
            />
            <table className="tables" style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", marginBottom: "8px", position: "relative", zIndex: 1 }}>
            <thead>
              <tr style={{ backgroundColor: "#FF3399", color: "white" }}>
                  <th style={{ width: "10%", border: "1px solid #dddddd", textAlign: "center", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Sr No</th>
                  <th style={{ width: "60%", border: "1px solid #dddddd", textAlign: "center", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Product</th>
                  <th style={{ width: "10%", border: "1px solid #dddddd", textAlign: "center", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Qty.</th>
                  <th style={{ width: "20%", border: "1px solid #dddddd", textAlign: "center", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(tableData) &&
                tableData.map((row, index) => (
                  <tr key={index} style={{ border: "1px solid #dddddd" }}>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontSize: "11px" }}>{index + 1}</td>
                    <td style={{ border: "1px solid #dddddd", padding: "6px", position: "relative", zIndex: 1, fontSize: "11px" }}>
                      <div style={{ position: "relative", zIndex: 2 }}>
                        <b>Model:</b> {row.model_name}
                      <br />
                        <b>IMEI:</b> {row.imei}
                      </div>
                    </td>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontSize: "11px" }}>{1}</td>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontWeight: "bold", fontSize: "11px" }}>&#8377;{row.price}/-</td>
                  </tr>
                ))}
              {Array.isArray(BuyBackData) && BuyBackData.length > 0 &&
                BuyBackData.map((row, index) => (
                  <tr key={`buyback-${index}`} style={{ border: "1px solid #dddddd" }}>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontSize: "11px" }}>{Array.isArray(tableData) ? tableData.length + index + 1 : index + 1}</td>
                    <td style={{ border: "1px solid #dddddd", padding: "6px", position: "relative", zIndex: 1, fontSize: "11px" }}>
                      <div style={{ position: "relative", zIndex: 2 }}>
                      <b>Model:</b> {row.model_name} (Buyback)
                      <br />
                      <b>IMEI:</b> {row.imei}
                      </div>
                    </td>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontSize: "11px" }}>{1}</td>
                    <td style={{ border: "1px solid #dddddd", textAlign: "center", padding: "6px", verticalAlign: "middle", fontWeight: "bold", color: "#d32f2f", fontSize: "11px" }}>- &#8377;{row.price}/-</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>



          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", marginBottom: "8px", border: "1px solid #dddddd" }}>
            <tbody>
              <tr>
                <td style={{ width: "70%", border: "1px solid #dddddd", padding: "8px", verticalAlign: "top" }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input type="checkbox" id="checkbox1" defaultChecked style={{ width: "14px", height: "14px", cursor: "pointer" }} />
                      <label htmlFor="checkbox1" style={{ margin: 0, cursor: "pointer", fontSize: "11px" }}>Handset</label>
                </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input type="checkbox" id="checkbox2" defaultChecked style={{ width: "14px", height: "14px", cursor: "pointer" }} />
                      <label htmlFor="checkbox2" style={{ margin: 0, cursor: "pointer", fontSize: "11px" }}>Charger</label>
              </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input type="checkbox" id="checkbox3" defaultChecked style={{ width: "14px", height: "14px", cursor: "pointer" }} />
                      <label htmlFor="checkbox3" style={{ margin: 0, cursor: "pointer", fontSize: "11px" }}>Box</label>
                </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input type="checkbox" id="checkbox4" style={{ width: "14px", height: "14px", cursor: "pointer" }} />
                      <label htmlFor="checkbox4" style={{ margin: 0, cursor: "pointer", fontSize: "11px" }}>Earphone</label>
                </div>
              </div>
                </td>
                <td style={{ width: "30%", border: "1px solid #dddddd", padding: "8px", verticalAlign: "top" }}>
                  {/* Empty space for alignment */}
                </td>
              </tr>
            </tbody>
          </table>


          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", border: "1px solid #dddddd" }}>
            <tbody>
              <tr>
                <td style={{ width: "66.67%", border: "1px solid #dddddd", padding: "8px", verticalAlign: "top" }}>
                  <p style={{ margin: "4px 0", fontSize: "11px", fontWeight: "bold" }}>टीप - कोणत्याही सेकेंड मोबाइल वॉरंटी येत नाही.</p>
                </td>
                <td style={{ width: "33.33%", border: "1px solid #dddddd", padding: "0", verticalAlign: "top" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Sub Total:</td>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", textAlign: "right", fontWeight: "bold", fontSize: "11px" }}>&#8377;{subTotal}/-</td>
                      </tr>
                      <tr>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", fontWeight: "bold", fontSize: "11px" }}>Discount:</td>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", textAlign: "right", fontWeight: "bold", fontSize: "11px" }}>&#8377;{discount}/-</td>
                      </tr>
                      <tr>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", fontWeight: "bold", fontSize: "12px" }}>Grand Total:</td>
                        <td style={{ width: "50%", border: "1px solid #dddddd", padding: "6px", textAlign: "right", fontWeight: "bold", fontSize: "12px", color: "#000" }}>&#8377;{grandTotal}/-</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>

          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "8px", border: "1px solid #dddddd" }}>
            <tbody>
              <tr>
                <td style={{ width: "35%", border: "1px solid #dddddd", padding: "8px", textAlign: "center", verticalAlign: "middle" }}>
                  <img src="https://png.pngtree.com/png-clipart/20220602/original/pngtree-satisfaction-guarantee-badges-png-image_7885136.png" height={90} width={90} style={{ mixBlendMode: "multiply", maxWidth: "100%", height: "auto" }} alt="Satisfaction Guarantee" />
                </td>
                <td style={{ width: "32.5%", border: "1px solid #dddddd", padding: "8px", textAlign: "center", verticalAlign: "middle" }}>
                  <img src="https://img.freepik.com/premium-vector/purple-gradiend-social-media-logo_197792-1883.jpg" height={60} width={60} style={{ mixBlendMode: "multiply", maxWidth: "100%", height: "auto", marginBottom: "5px" }} alt="Instagram" />
                  <br />
                  <b style={{ fontSize: "11px" }}>@Mobilecitygadhinglaj</b>
                </td>
                <td style={{ width: "32.5%", border: "1px solid #dddddd", padding: "8px", textAlign: "center", verticalAlign: "middle" }}>
                  <img src="assets/img/Mobile City Stamp and Signature.png" alt="Mobile City Stamp and Signature" style={{ width: "90px", height: "auto", marginBottom: "5px", maxWidth: "100%", display: "block", margin: "0 auto 5px" }} />
                  <b style={{ fontSize: "12px" }}>Mobile City</b>
                </td>
              </tr>
            </tbody>
            </table>

          {/* <table style={{marginTop:"14%"}} >
          
            <tr >
              <th style={{width:"50%"}}> टीप - कोणत्याही सेकेंड मोबाइल वॉरंटी येत नाही.</th>
              <th></th>
              <th style={{width:"20%"}}>Total Amount:</th>
              <th>1000</th>
            </tr>

            <tr>
              <th style={{width:"20%"}}>Customer Sign</th>
              <th></th>
              <th><span>Signature</span></th>
              <th style={{width:"20%"}}>
              
              </th>
            </tr>
          </table> */}
        </div>
      </section>

    </>


  );
}


